var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDuration = function SvgDuration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.358 9.559c-.281-.281.14-.703.422-.422l1.37 1.371c.14.105.106.316 0 .422L4.78 12.3c-.281.281-.703-.14-.422-.421L5.237 11C2.32 10.86 0 8.434 0 5.518A5.504 5.504 0 0 1 5.518 0C8.54 0 11 2.46 11 5.518c0 .984-.246 1.932-.738 2.776-.21.316-.703.035-.527-.316.457-.738.668-1.617.668-2.46 0-2.742-2.18-4.92-4.886-4.92a4.89 4.89 0 0 0-4.92 4.92c0 2.6 2.039 4.744 4.604 4.885l-.843-.844Z",
    fill: "#102B3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.201 2.917c0-.387.598-.387.598 0v2.46l1.44 1.16c.282.246-.105.702-.386.457L5.342 5.728a.296.296 0 0 1-.14-.246V2.917Z",
    fill: "#102B3F"
  })));
};

export default SvgDuration;